import type { TemplateResult } from "lit";
import { html } from "lit";

export function renderDivider(): TemplateResult {
  return html`
    <div class="divider container container-sm">
      <div class="divider-line"></div>
    </div>
  `;
}
